module.exports = __webpack_public_path__ + "img/2.4720f645.jpg";